const suggestedActionsData = [

    "Correlate with patient's clinical presentation",
    "Correlate with cardiac markers",
    "Please refer suggested clinical guidance",
    "Please re-take ECG",
    "Lead placement incorrect",
    "Consult to the cardiologist"
];

export default suggestedActionsData;
